import React from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import "../../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/exam-pages-styles/MockExamLanding.css";
import { useNavigate } from "react-router-dom";

const MockExamInstructions = () => {
  const navigate = useNavigate();
  const handleNextClick = () => {
    alert("Navigating to the first question");
  };

  return (
    <div>
      <Navbar expand="lg" className="bg-body-primary">
        <Container>
          <Navbar.Brand href="#home"> PassMedicine</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <NavDropdown title="Options" id="basic-nav-dropdown">
                <NavDropdown.Item href="#action/3.2">
                  Save and Exit
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">
                  Abandon and Exit
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="exam-container">
        <header className="exam-header"></header>

        <main className="exam-content">
          <h1>Pre-examination guidance</h1>

          <div className="exam-instructions">
            <p>
              In this mock exam there are 200 questions to answer within 190
              minutes
            </p>

            <p>
              Before the real you'll exam be shown and asked to agree to a
              Non-Disclosure Agreement and Code of Conduct Agreement.
            </p>

            <p>
              You'll also be given a tutorial on how to use the system. This
              will include details on keyboard shortcuts:
            </p>

            <p>
              <ol>
                <li>Previous: Alt + P</li>
                <li>Next: Alt + N</li>
                <li>a, b, c, d, e can be used to select the answer</li>
              </ol>
            </p>
            <p>
              In the top right of the screen you'll be able to see the time
              remaining, current question position. There is also an option to
              flag the question in case you wish to return to it later.
            </p>

            <p>
              Once you click <strong>Next</strong> in the bottom right the exam
              will start.
            </p>
          </div>
        </main>

        <footer className="exam-footer">
          <button 
              className="next-button"
              onClick={() => {
                navigate("/mock-exam-questions")
              }}
          >
            Next →
          </button>
        </footer>
      </div>
    </div>
  );
};

export default MockExamInstructions;
